import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import PremiumRequiredScreen from './PremiumRequiredScreen';

const PrivateRoute = ({ children, requirePremium = false, requireAdmin = false }) => {
  const { isAuthenticated, isPremium, isAdmin, loading } = useAuth();

  if (loading) return <div className="loading">Yukleniyor...</div>;
  if (!isAuthenticated) return <Navigate to="/login" />;
  if (requireAdmin && !isAdmin) return <Navigate to="/" />;
  if (requirePremium && !isPremium && !isAdmin) return <PremiumRequiredScreen />;

  return children;
};

export default PrivateRoute;
